import { Box, Grid, Typography, Container, Card } from "@mui/material";
import { useDomainConfig } from "../../hooks/useDomainConfig";
import googlePlayStore from "../../image/android-download.svg";
import applePlayStore from "../../image/app-store.png";

import { Email, Language, PhoneAndroid } from "@mui/icons-material";
import WhatsappImg from "../../image/whatsapp_logo.png";
import Page from "../Page";
// import googlePlayStore from "../.../image/app-store.png"

// ----------------------------------------------------------------------

export default function DomainScanner() {
  const domainConfig = useDomainConfig();

  return (
    <Page title={`${domainConfig.domain} | ChargeMiles`} sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', py: { xs: 4, md: 8 } }}>
      <Container maxWidth="sm">
        <Typography variant="h3" sx={{ textAlign: 'center', mb: 4, fontWeight: 700, color: 'text.primary' }}>
          Welcome to <span style={{ color: 'var(--app-color)' }}>{domainConfig.domain}</span>
        </Typography>
        
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: (theme) => `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: { xs: 3, md: 4 },
            }}
          >
            <Box
              component="img"
              src={domainConfig.logoUrl}
              sx={{ 
                height: 60,
                objectFit: 'contain',
                filter: 'brightness(0) invert(1)' // Make logo white if applicable, or remove this if logos are colored/complex
              }}
            />
          </Box>

          <Box sx={{ p: { xs: 3, md: 4 } }}>
            <Grid container spacing={3}>
              
              {/* Web Links */}
              <Grid item xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, mb: 1, display: 'block' }}>
                  Contact Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} display="flex" alignItems="center">
                    <Language sx={{ width: 24, height: 24, color: 'primary.main', mr: 2 }} />
                    <Typography variant="body1" fontWeight={500}>
                      <a href={`${domainConfig.websiteUrl}`} target="blank" style={{ textDecoration: "none", color: "inherit" }}>
                        {domainConfig.websiteUrl}
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} display="flex" alignItems="center">
                    <Email sx={{ width: 24, height: 24, color: 'primary.main', mr: 2 }} />
                    <Typography variant="body1" fontWeight={500}>
                      <a href={`mailto:${domainConfig.email}`} target="blank" style={{ textDecoration: "none", color: "inherit" }}>
                        {domainConfig.email}
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} display="flex" alignItems="center">
                    <PhoneAndroid sx={{ width: 24, height: 24, color: 'primary.main', mr: 2 }} />
                    <Typography variant="body1" fontWeight={500}>
                      <a href={`tel:${domainConfig.countryCode}${domainConfig.phone}`} target="blank" style={{ textDecoration: "none", color: "inherit" }}>
                        {domainConfig.countryCode} {domainConfig.phone}
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} display="flex" alignItems="center">
                    <Box component="img" src={WhatsappImg} sx={{ width: 24, height: 24, mr: 2 }} />
                    <Typography variant="body1" fontWeight={500}>
                      <a href={`https://wa.me/${domainConfig.countryCode}${domainConfig.whatsappContact}`} target="blank" style={{ textDecoration: "none", color: "inherit" }}>
                        {domainConfig.countryCode} {domainConfig.whatsappContact}
                      </a>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* App Links */}
              <Grid item xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, mb: 2, display: 'block', mt: 1 }}>
                  Download Our App
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={6}>
                    <a href={`${domainConfig.appStoreUrl}`} target="blank" style={{ display: 'block' }}>
                      <Box component="img" src={applePlayStore} sx={{ width: '100%', maxWidth: 160, height: 'auto', display: 'block', mx: 'auto' }} />
                    </a>
                  </Grid>
                  <Grid item xs={6}>
                    <a href={`${domainConfig.playStoreUrl}`} target="blank" style={{ display: 'block' }}>
                      <Box component="img" src={googlePlayStore} sx={{ width: '100%', maxWidth: 160, height: 'auto', display: 'block', mx: 'auto' }} />
                    </a>
                  </Grid>
                </Grid>
              </Grid>

              {/* Address Links */}
              <Grid item xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, mb: 1, display: 'block', mt: 1 }}>
                  Office Locations
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" fontWeight={700} color="text.primary">Registered Office</Typography>
                  <Typography variant="body2" color="text.secondary">{domainConfig.registeredOffice}</Typography>
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={700} color="text.primary">Regional Office</Typography>
                  <Typography variant="body2" color="text.secondary">{domainConfig.regionalOffice}</Typography>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
